import clsx from "clsx";
import { getTimeSlots, isTimeSelected } from "csi/utility/dateUtility";
import { FlexColumn, FlexRowCenter, Text } from "designSystem/index";
import { observer } from "mobx-react-lite";
import React, { forwardRef } from "react";
import styles from "./DateRangeTimePicker.module.css";
import { useDateRangeTimePickerStore } from "./DateRangeTimePickerStore";

interface TimeSlotsProps {
	/** flag indicating whether this is the destination time */
	isToTime?: boolean;
}

export const TimeSlots = observer(forwardRef<HTMLDivElement, TimeSlotsProps>(
	({ isToTime }, ref) => {
		const {
			disabledFromTime,
			disabledToTime,
			selectedTimeSlotFrom,
			selectedTimeSlotTo,
			handleTimeChange,
		} = useDateRangeTimePickerStore();
		const disabled = isToTime ? disabledToTime : disabledFromTime;
		const selectedTime = isToTime ? selectedTimeSlotTo : selectedTimeSlotFrom;

		return (
			<FlexColumn borderLeft="1px solid var(--Grey400)">
				<FlexRowCenter p={2}>
					<Text res={isToTime ? "DateRangeTimePicker_EndTime" : "DateRangeTimePicker_StartTime"} />
				</FlexRowCenter>
				<FlexColumn
					className={styles.customComponentsTimeBackground}
					m={2}
					maxHeight={260}
					overflow="auto"
					p={2}
					ref={ref}
				>
					{getTimeSlots().map((time, index) => (
						<div
							className={clsx(
								styles.customComponentsTime,
								!disabled && isTimeSelected(time, selectedTime) && styles.customComponentsSelectedTime,
								disabled && styles.customComponentsTimeDisabled,
							)}
							key={index}
							onClick={() => handleTimeChange(time, isToTime)}
						>
							<Text text={time} />
						</div>
					))}
				</FlexColumn>
			</FlexColumn>
		);
	},
));
